import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62980c4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login-tips" }, "未注册的手机号验证后将自动创建账号", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.ruleForm,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "prefix-icon": _ctx.User,
              modelValue: _ctx.ruleForm.mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.mobile) = $event)),
              required: "",
              placeholder: "请输入手机号",
              autocomplete: "off"
            }, null, 8, ["prefix-icon", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "code"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "prefix-icon": _ctx.Lock,
              required: "",
              placeholder: "请输入验证码",
              class: _normalizeClass(["phone-code", { 'disabled-phone-code': _ctx.disabledBtn }]),
              modelValue: _ctx.ruleForm.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.code) = $event))
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  disabled: _ctx.disabledBtn,
                  type: "primary",
                  onClick: _ctx.getCode
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.codeMsg), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["prefix-icon", "class", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "submit-btn",
              type: "primary",
              loading: _ctx.isLoading,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitForm(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _hoisted_2
  ]))
}